import { Highmaps } from "extensions/highcharts";

import { Chart } from "common/components/charts/chart";
import { ensureErrorCallback } from "common/components/error";
import { toHex } from "common/colors";

export const MapChart = Chart.extend({
    chartType: "map",
    
    constructor: function constructor() {
        Chart.apply(this, arguments);
        
        this.extendChartOptions({
            credits: {
                enabled: false
            },
            mapNavigation: {
                enabled: true
            },
            colorAxis: {
                minColor: toHex("canvas-dark"),
                maxColor: toHex("blue-light")
            }
        });
    },
    
    initialize() {
        this.listenTo(this.collection, "before:fetch", this.showLoader);
        this.listenTo(this.collection, "fetched", this.render);
    },
    
    getChartConstructor() {
        return Highmaps.Map;
    },
    
    async render(...args) {
        try {
            const { WorldMap } = await import(
                /* webpackChunkName: "worldMap" */
                "map/world"
            );
            
            // Set map viewSeriaModifier to inject mapData into each map seria
            this.viewSeriaModifier = {
                mapData: WorldMap
            };
    
            // If chart is not yet destroyed at this point, then render it
            if (!this.isDestroyed()) {
                Chart.prototype.render.apply(this, args);
            }
        } catch (error) {
            ensureErrorCallback(error);
        }
    }
});
